/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-left-bold': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M20 9v6h-8v4.84L4.16 12 12 4.16V9h8z"/>'
  }
})
